export enum ScenicBikeRideCategory {
    ARCHITECTURAL = 'ARCHITECTURAL',
    COASTAL = 'COASTAL',
    FOREST = 'FOREST',
    HISTORICAL = 'HISTORICAL',
    ISLAND = 'ISLAND',
    LAKESIDE = 'LAKESIDE',
    MOUNTAIN = 'MOUNTAIN',
    NATURE = 'NATURE',
    PANORAMIC = 'PANORAMIC',
    RIVERSIDE = 'RIVERSIDE',
    RURAL = 'RURAL',
    TRAIL = 'TRAIL',
    URBAN = 'URBAN',
    VALLEY = 'VALLEY',
}

export const SCENIC_BIKE_RIDE_CATEGORY_LABELS: Record<ScenicBikeRideCategory, string> = {
    ARCHITECTURAL: 'Architectural',
    COASTAL: 'Coastal',
    FOREST: 'Forest',
    HISTORICAL: 'Historic',
    ISLAND: 'Island',
    LAKESIDE: 'Lakeside',
    MOUNTAIN: 'Mountain',
    NATURE: 'Nature',
    PANORAMIC: 'Panoramic',
    RIVERSIDE: 'Riverside',
    RURAL: 'Rural',
    TRAIL: 'Scenic',
    URBAN: 'Urban',
    VALLEY: 'Valley',
};